import { memo } from "react"
import { cn } from "@/utils/cn"
import { IconProps } from "@/components/shared/icons"

export interface TabData {
  title: string
  id: string
  count?: number
  icon?: (props: IconProps) => JSX.Element
}

interface TabProps extends TabData {
  isActive: boolean
  marginLeft: string
  isFirst: boolean
  tabClassName?: string
  onClick: (id: string) => void
  tabRef: (element: HTMLDivElement | null) => void
}

const Tab = memo(
  ({ id, title, count, icon: Icon, isActive, marginLeft, isFirst, tabClassName, onClick, tabRef }: TabProps) => {
    return (
      <div
        role="tab"
        id={id}
        aria-selected={isActive}
        aria-controls={`${id}-panel`}
        tabIndex={0}
        style={{ marginLeft: isFirst ? 0 : marginLeft }}
        className={cn(
          "font-semibold text-atherGray-500 cursor-pointer flex items-center whitespace-nowrap",
          "transition-colors duration-200 hover:text-atherGray-300",
          {
            "text-white": isActive,
          },
          tabClassName,
        )}
        onClick={() => onClick(id)}
        onKeyDown={e => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault()
            onClick(id)
          }
        }}
        ref={tabRef}
      >
        {Icon && <Icon className="mr-1" width={16} height={16} />}
        {title}
        {(count ?? 0) > 0 && <span className="ml-1">({count})</span>}
      </div>
    )
  },
)

Tab.displayName = "Tab"

export default Tab
